import { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';

export const useDashboard = () => {
  const [summary, setSummary] = useState(null);
  const [subscriptions, setSubscriptions] = useState(null);
  const [magi, setMagi] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [monthlySpend, setMonthlySpend] = useState([]);
  const [plannedExpenses, setPlannedExpenses] = useState(null);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState(null);
  const [lastRefresh, setLastRefresh] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [sumData, subData, magiData, acctData, monthData, plannedData] = await Promise.all([
        api.getSummary(),
        api.getSubscriptions(),
        api.getMagi(),
        api.getAccounts(),
        api.getSpendingByMonth(),
        api.getPlannedExpenses(),
      ]);
      setSummary(sumData);
      setSubscriptions(subData);
      setMagi(magiData);
      setAccounts(acctData);
      setMonthlySpend(monthData);
      setPlannedExpenses(plannedData);
      setLastRefresh(new Date());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    // Auto-refresh every 5 minutes
    const interval = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [load]);

  const sync = async () => {
    setSyncing(true);
    try {
      await api.syncAccounts();
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setSyncing(false);
    }
  };

  return {
    summary,
    subscriptions,
    magi,
    accounts,
    monthlySpend,
    plannedExpenses,
    loading,
    syncing,
    error,
    lastRefresh,
    refresh: load,
    sync,
  };
};
